import parseParams from '@/assets/js/shared/helpers/parseParams';

/**
 * Formats a query/session name for display (Mary_alice → Mary Alice).
 * @param {string} name
 * @returns {string}
 */
const formatDisplayName = name =>
  parseParams({
    word: name,
    splitBy: ['_', '+', ' '],
    parseBy: ' '
  });

export default formatDisplayName;
